var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountSettingIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33366 8.33333C9.33366 9.06973 8.73673 9.66667 8.00033 9.66667C7.26393 9.66667 6.66699 9.06973 6.66699 8.33333C6.66699 7.59693 7.26393 7 8.00033 7C8.73673 7 9.33366 7.59693 9.33366 8.33333Z",
    fill: "#0D0D0D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 11.5003C7.81767 11.5003 7.54574 11.5917 7.12154 11.9877C6.8524 12.2389 6.43052 12.2244 6.1793 11.9552C5.92808 11.6861 5.94262 11.2642 6.21179 11.0129C6.73994 10.52 7.3252 10.167 8 10.167C8.6748 10.167 9.26007 10.52 9.7882 11.0129C10.0574 11.2642 10.0719 11.6861 9.82074 11.9552C9.56947 12.2244 9.1476 12.2389 8.87847 11.9877C8.45427 11.5917 8.18234 11.5003 8 11.5003Z",
    fill: "#0D0D0D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66699 3.33301C2.66699 2.22844 3.56243 1.33301 4.66699 1.33301H11.3337C12.4383 1.33301 13.3337 2.22844 13.3337 3.33301V12.6663C13.3337 13.7709 12.4383 14.6663 11.3337 14.6663H4.66699C3.56243 14.6663 2.66699 13.7709 2.66699 12.6663V3.33301ZM4.66699 2.66634C4.29881 2.66634 4.00033 2.96482 4.00033 3.33301V12.6663C4.00033 13.0345 4.29881 13.333 4.66699 13.333H11.3337C11.7019 13.333 12.0003 13.0345 12.0003 12.6663V3.33301C12.0003 2.96482 11.7019 2.66634 11.3337 2.66634H4.66699Z",
    fill: "#0D0D0D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4.66667C6 4.29848 6.29848 4 6.66667 4H9.33333C9.70153 4 10 4.29848 10 4.66667C10 5.03485 9.70153 5.33333 9.33333 5.33333H6.66667C6.29848 5.33333 6 5.03485 6 4.66667Z",
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountSettingIcon);
export default __webpack_public_path__ + "static/media/AccountSettingIcon.c6cd2eaeb0423f3113b80ed67a1e3647.svg";
export { ForwardRef as ReactComponent };